import React from "react";
import axios from "axios";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const GetCheckbox = ({ label, name, handleChange }) => {
  return (
    <FormControlLabel
      control={<Checkbox onChange={handleChange} name={name} color="primary" />}
      label={label}
    />
  );
};

export default function FilterDialog({ setData, setNewsFilteropen, open }) {
  const [selectedCurrencies, setSelectedCurrencies] = React.useState([]);
  const list = [
    { label: "Bitcoin", name: "BTC" },
    { label: "LiteCoin", name: "LTC" },
    { label: "Etherium", name: "ETH" },
    { label: "DogeCoin", name: "DOGE" },
    { label: "Cardano", name: "ADA" },
    { label: "Binance Coin", name: "BNB" },
    { label: "Ripple Coin", name: "XRP" },
    { label: "The Currency Analytics", name: "TCAT" },
    { label: "Spectre Security Coin", name: "XSPC" },
    { label: "Delta Exchange Token", name: "DETO" },
    { label: "EOS Coin", name: "EOS" },
    { label: "Gains Farm", name: "GFARM2" },
    { label: "Polkadot", name: "DOT" },
  ];

  const handleClose = () => {
    setNewsFilteropen(false);
    setSelectedCurrencies([]);
  };

  const filterNews = () => {
    if (selectedCurrencies.length === 0) {
      alert("select at least one currency");
      return;
    }
    console.log("getting filtered news for: ", selectedCurrencies);

    axios
      .post(
        "https://crypto-prediction-nac.herokuapp.com/get-filtered-news",
        {
          selectedCurrencies,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("filtered news: ", res.data.data);
        setData(res.data.data);
      })
      .catch((err) => console.log(err.message));

    handleClose();
  };

  const handleChange = (e) => {
    if (e.target.checked) {
      //if (selectedCurrencies.includes(e.target.name)) return;
      console.log("adding: ", e.target.name);
      setSelectedCurrencies(selectedCurrencies.concat(e.target.name));
    } else {
      console.log("removing: ", e.target.name);
      setSelectedCurrencies(
        selectedCurrencies.filter((currency) => currency !== e.target.name)
      );
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>
        <Typography variant="h6" color="secondary">
          Filter News
        </Typography>
      </DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          <FormGroup>
            {list.map((c) => (
              <GetCheckbox
                name={c.name}
                label={c.label}
                handleChange={handleChange}
              />
            ))}
          </FormGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" size="small">
          Cancel
        </Button>
        <Button
          onClick={() => filterNews()}
          color="secondary"
          variant="contained"
          size="small"
        >
          Filter
        </Button>
      </DialogActions>
    </Dialog>
  );
}
